module.exports = __webpack_public_path__ + "static/media/404@2x.210931e5.png";